export default "__VITE_ASSET__DB3qO7jH__"